module.exports = {
  // 正式服务器
  api: {
    host: 'open-api.365jia.cn',
    port: '',
    protocol: 'https'
  }
}
